import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeadingItem } from 'components'
import { CheckBox, TextBox } from 'devextreme-react'
import React, { FC, Fragment } from 'react'
import { RecapField } from 'services/enums'
import { Signature } from 'services/types'
import './recap-signature.scss'

type Props = {
    isSignaturePopupVisible: boolean,
    isRecapReadOnly: boolean,
    signatureField: Signature,
    onValueChanged: (recapField: RecapField, e: any) => void,
    onClickTapToSign: () => void
}

export const RecapSignature: FC<Props> = ({ isRecapReadOnly, signatureField, onValueChanged, onClickTapToSign }) => {

    return (
      <Fragment>
        <HeadingItem text='Receiver Signature' />
        <div className={'recap-signature-checkbox'}>
          <CheckBox
            name={'Accept'}
            value={signatureField.acceptAll}
            disabled={isRecapReadOnly}
            onValueChanged={e => onValueChanged(RecapField.Accept, { value: e.value })}
          />
          <div className={'recap-signature-text required-checkbox-field'}>I have reviewed & accept all the changes</div>
        </div>
        <div className={'recap-signature-textbox'}>
          <TextBox
            disabled={isRecapReadOnly}
            name={'Name'}
            placeholder="Your Name (Required)"
            value={signatureField.receiverName}
            onValueChanged={(e) => onValueChanged(RecapField.Name, { value: e.value })}
          />
        </div>
            <div className={'recap-signature-box'} onClick={onClickTapToSign} style={{ backgroundColor: isRecapReadOnly == true ? '#f1f1f1' : 'transparent' }}>
                {signatureField.signatureImage ?
                    <Fragment>
                        <img src={signatureField.signatureImage} className={'recap-signature-image'}></img>
                        {!isRecapReadOnly && <div className={'recap-signature-taptoresign'}>Tap to Re-Sign</div>}
                    </Fragment>
                    :
                    <div className={'recap-signature-taptosign'}>Tap to Sign</div>
                }
            </div>
            {!isRecapReadOnly &&
                <div className={'recap-signature-footer'}>
                    <div className={`recap-signature-footer-icon`}>
                        <FontAwesomeIcon icon={faExclamationCircle as IconProp} size={'1x'} color={'#EB5757'} />
                </div>
                    <div className={`recap-signature-footer-text`}>Only the receiver should sign here</div>
        </div>
            }
        </Fragment>
    )
}